import { createContext } from "react";

const SubToSubActivityContext = createContext({});

export default SubToSubActivityContext;
